module.exports = __webpack_public_path__ + "static/car-pc/img/star-half-icon.b2fe6f26.svg";